import { designToken, quickProperty } from '../component-tokens';
export const codeData = {
    name: 'code',
    tag: 'chameleon-code',
    reactImports: 'Code',
    attributes: {
        'justify-content': quickProperty('space-between'),
        'border-radius': quickProperty('4px'),
        'background-color': designToken('ui-04'),
        font: designToken('code-text-small'),
        color: designToken('text-01'),
        padding: quickProperty('0 4px 0 16px'),
        display: quickProperty('inline-flex'),
        gap: quickProperty('20px'),
        width: quickProperty('100%'),
        'box-sizing': quickProperty('border-box'),
    },
    children: [
        {
            name: 'content',
            attributes: {
                margin: quickProperty('12px 0'),
            },
        },
        {
            name: 'selection',
            attributes: {
                'background-color': designToken('highlight-base'),
            },
        },
    ],
    variants: [
        {
            name: 'inline',
            attributes: {
                width: quickProperty('auto'),
                padding: quickProperty('0 8px'),
                margin: quickProperty('0 4px'),
            },
            children: [
                {
                    name: 'content',
                    attributes: {
                        margin: quickProperty('4px 0'),
                    },
                },
            ],
        },
    ],
};
